export const COLOR_WHITE = '#FFFFFF';
export const COLOR_ACTION_BLUE_10 = 'rgba(25, 97, 225, 0.1)';
export const COLOR_ACTION_BLUE_20 = 'rgba(25, 97, 225, 0.2)';
export const COLOR_ACTION_BLUE_30 = 'rgba(25, 97, 225, 0.3)';
export const COLOR_ACTION_BLUE_40 = 'rgba(25, 97, 225, 0.4)';
export const COLOR_ACTION_BLUE_70 = 'rgba(25, 97, 225, 0.7)';
export const COLOR_ACTION_BLUE_90 = 'rgba(25, 97, 225, 0.9)';
export const COLOR_ACTION_BLUE = '#1961E1';
export const COLOR_TEXT_BLUE = '#1D3052';
export const COLOR_KASVU_BLUE = '#334B76';
export const COLOR_DARKEST_BLUE = '#162332';
export const COLOR_DARKEST_GREY = '#444F62';
export const COLOR_DARK_GREY = '#5e6872';
export const COLOR_LINE_GREY = '#E6E6E6';
export const COLOR_PALE = '#F7F7F7';
export const COLOR_ACCORDION_PALE = '#F2F2F2';
export const COLOR_SUPER_PALE = '#FAFAFA';
export const COLOR_PALE_SALMON = '#EFC2A9';
export const COLOR_SUPER_PALE_SALMON = '#F5E5D6';
export const COLOR_KASVU_THEME = '#AEBFC6';
export const COLOR_KASVU_THEME_LIGHT = '#E8EDEF';
export const COLOR_INVOICER_GREEN = '#46B993';
export const COLOR_INVOICER_PALE_GREEN = '#F2F8F6';
export const COLOR_ERROR_RED = '#EB5757';
export const COLOR_SUCCESS_GREEN = '#219653';
export const COLOR_WARNING_ORANGE = '#F2994A';
export const COLOR_GREY_BLUE = '#9BA8BD';
export const COLOR_CENTER_BORDER = '#EBEBEA';

export const TYPOGRAPHY_HERO_SIZE = 56;
export const TYPOGRAPHY_HERO_LINE_HEIGHT = 62 / TYPOGRAPHY_HERO_SIZE;
export const TYPOGRAPHY_HERO_WEIGHT = 700;
export const TYPOGRAPHY_H1_SIZE = 42;
export const TYPOGRAPHY_H1_LINE_HEIGHT = 46 / TYPOGRAPHY_H1_SIZE;
export const TYPOGRAPHY_H1_WEIGHT = 700;
export const TYPOGRAPHY_H2_SIZE = 32;
export const TYPOGRAPHY_H2_LINE_HEIGHT = 40 / TYPOGRAPHY_H2_SIZE;
export const TYPOGRAPHY_H2_WEIGHT = 500;
export const TYPOGRAPHY_H3_SIZE = 24;
export const TYPOGRAPHY_H3_LINE_HEIGHT = 30 / TYPOGRAPHY_H3_SIZE;
export const TYPOGRAPHY_H3_WEIGHT = 500;
export const TYPOGRAPHY_H4_SIZE = 18;
export const TYPOGRAPHY_H4_LINE_HEIGHT = 26 / TYPOGRAPHY_H4_SIZE;
export const TYPOGRAPHY_H4_WEIGHT = 500;
export const TYPOGRAPHY_H5_SIZE = 16;
export const TYPOGRAPHY_H5_LINE_HEIGHT = 24 / TYPOGRAPHY_H5_SIZE;
export const TYPOGRAPHY_H5_WEIGHT = 700;
export const TYPOGRAPHY_H6_SIZE = 16;
export const TYPOGRAPHY_H6_LINE_HEIGHT = 19.2 / TYPOGRAPHY_H6_SIZE;
export const TYPOGRAPHY_H6_WEIGHT = 700;
export const TYPOGRAPHY_BODY_SIZE = 16;
export const TYPOGRAPHY_BODY_LINE_HEIGHT = 24 / TYPOGRAPHY_BODY_SIZE;
export const TYPOGRAPHY_BODY_WEIGHT = 500;
export const TYPOGRAPHY_BODY_LARGE_SIZE = 18;
export const TYPOGRAPHY_BODY_LARGE_LINE_HEIGHT = 26 / TYPOGRAPHY_BODY_LARGE_SIZE;
export const TYPOGRAPHY_BODY_LARGE_WEIGHT = 500;
export const TYPOGRAPHY_BODY_SMALL_SIZE = 14;
export const TYPOGRAPHY_BODY_SMALL_LINE_HEIGHT = 20 / TYPOGRAPHY_BODY_SMALL_SIZE;
export const TYPOGRAPHY_BODY_SMALL_WEIGHT = 400;
export const TYPOGRAPHY_LINK_SIZE = 16;
export const TYPOGRAPHY_LINK_LINE_HEIGHT = 24 / TYPOGRAPHY_LINK_SIZE;
export const TYPOGRAPHY_LINK_WEIGHT = 500;
export const TYPOGRAPHY_BUTTON_SIZE = 16;
export const TYPOGRAPHY_BUTTON_LINE_HEIGHT = 24 / TYPOGRAPHY_BODY_SMALL_SIZE;
export const TYPOGRAPHY_BUTTON_WEIGHT = 400;
export const TYPOGRAPHY_HERO_SIZE_MOBILE = 36;
export const TYPOGRAPHY_HERO_LINE_HEIGHT_MOBILE = 42 / TYPOGRAPHY_HERO_SIZE_MOBILE;
export const TYPOGRAPHY_H1_SIZE_MOBILE = 34;
export const TYPOGRAPHY_H1_LINE_HEIGHT_MOBILE = 40 / TYPOGRAPHY_H1_SIZE_MOBILE;
export const TYPOGRAPHY_H2_SIZE_MOBILE = 28;
export const TYPOGRAPHY_H2_LINE_HEIGHT_MOBILE = 36 / TYPOGRAPHY_H2_SIZE_MOBILE;
export const TYPOGRAPHY_H3_SIZE_MOBILE = 22;
export const TYPOGRAPHY_H3_LINE_HEIGHT_MOBILE = 28 / TYPOGRAPHY_H3_SIZE_MOBILE;
export const TYPOGRAPHY_H4_SIZE_MOBILE = 18;
export const TYPOGRAPHY_H4_LINE_HEIGHT_MOBILE = 26 / TYPOGRAPHY_H4_SIZE_MOBILE;
export const TYPOGRAPHY_H5_SIZE_MOBILE = 16;
export const TYPOGRAPHY_H5_LINE_HEIGHT_MOBILE = 24 / TYPOGRAPHY_H5_SIZE_MOBILE;
export const TYPOGRAPHY_H6_SIZE_MOBILE = 16;
export const TYPOGRAPHY_H6_LINE_HEIGHT_MOBILE = 24 / TYPOGRAPHY_H6_SIZE_MOBILE;
export const TYPOGRAPHY_BODY_SIZE_MOBILE = 16;
export const TYPOGRAPHY_BODY_LINE_HEIGHT_MOBILE = 24 / TYPOGRAPHY_BODY_SIZE_MOBILE;
export const TYPOGRAPHY_BODY_LARGE_SIZE_MOBILE = 18;
export const TYPOGRAPHY_BODY_LARGE_LINE_HEIGHT_MOBILE = 26 / TYPOGRAPHY_BODY_LARGE_SIZE_MOBILE;
export const TYPOGRAPHY_BODY_SMALL_SIZE_MOBILE = 14;
export const TYPOGRAPHY_BODY_SMALL_LINE_HEIGHT_MOBILE = 20 / TYPOGRAPHY_BODY_SMALL_SIZE_MOBILE;
export const TYPOGRAPHY_BUTTON_SIZE_MOBILE = 16;
export const TYPOGRAPHY_BUTTON_LINE_HEIGHT_MOBILE = 24 / TYPOGRAPHY_BODY_SMALL_SIZE;
export const TYPOGRAPHY_LINK_SIZE_MOBILE = 16;
export const TYPOGRAPHY_LINK_LINE_HEIGHT_MOBILE = 24 / TYPOGRAPHY_LINK_SIZE_MOBILE;

export const SHADOW_FLOAT_ELEVATED_LARGE = '0px 4px 16px 0px #1D30521A'; // opacity: 10%
export const SHADOW_FLOAT_ELEVATED_MEDIUM = '0px 2px 6px 0px #1D30521A'; // opacity: 10%
export const SHADOW_FLOAT_ELEVATED_SMALL = '0px 2px 4px 0px #1623321F'; // opacity: 12%
